import {
  alignCenterCellStyle,
} from '@common/cellStyles';
import {
  companyCodeColumnDefinition,
  companyCodeLinkColumnDefinition,
  ccDescriptionColumnDefinition,
  accountColumnDefinition,
  tradingPartnerColumnDefinition,
  costCenterColumnDefinition,
  geographyColumnDefinition,
  projectColumnDefinition,
  referenceColumnDefinition,
  bookTypeColumnDefinition,
  productLineColumnDefinition,
  enteredCurrencyColumnDefinition,
  customEnteredDebitColumnDefinition,
  customEnteredCreditColumnDefinition,
  accountDescriptionColumnDefinition,
  legalEntityColumnDefinition,
  managementEntityColumnDefinition,
  localAccountColumnDefinition,
  ileColumnDefinition,
  imeColumnDefinition,
  localAccountDescriptionColumnDefinition,
  statusColumnDefinition,
  notesColumnDefinition,
  connectionNameColumnDefinition,
  countryNameColumnDefinition,
  updatedOnColumnDefinition,
  importResultsColumnDefinition,
} from '../columnDefinitions';

export const defaultColumnDefs = {
  ...alignCenterCellStyle,
};

export const commonColumnDefs = [
  companyCodeLinkColumnDefinition,
  ccDescriptionColumnDefinition,
  legalEntityColumnDefinition,
  { ...countryNameColumnDefinition, headerName: 'Country' },
];

export const allCompaniesColumnDefs = [
  ...commonColumnDefs,
  statusColumnDefinition,
  { ...updatedOnColumnDefinition, headerName: 'Last Update', sort: 'desc' },
];

export const processedSuccessfullyColumnDefs = [
  ...commonColumnDefs,
  { ...updatedOnColumnDefinition, headerName: 'Date Time' },
  statusColumnDefinition,
];

export const trialBalancesNotReceivedColumnDefs = [
  ...commonColumnDefs,
  statusColumnDefinition,
];

export const trialBalancesValidationErrorsColumnDefs = [
  ...commonColumnDefs,
  importResultsColumnDefinition,
  statusColumnDefinition,
];

export const calculationErrorsColumnDefs = [
  ...commonColumnDefs,
  statusColumnDefinition,
];

export const otherErrorsColumnDefs = [
  connectionNameColumnDefinition,
  companyCodeColumnDefinition,
  notesColumnDefinition,
];

export const journalsColumnDefs = [
  companyCodeColumnDefinition,
  accountColumnDefinition,
  tradingPartnerColumnDefinition,
  costCenterColumnDefinition,
  geographyColumnDefinition,
  projectColumnDefinition,
  referenceColumnDefinition,
  bookTypeColumnDefinition,
  productLineColumnDefinition,
  enteredCurrencyColumnDefinition,
  customEnteredDebitColumnDefinition,
  customEnteredCreditColumnDefinition,
  accountDescriptionColumnDefinition,
];

export const localJournalsColumnDefs = [
  legalEntityColumnDefinition,
  managementEntityColumnDefinition,
  localAccountColumnDefinition,
  ileColumnDefinition,
  imeColumnDefinition,
  bookTypeColumnDefinition,
  enteredCurrencyColumnDefinition,
  customEnteredDebitColumnDefinition,
  customEnteredCreditColumnDefinition,
  localAccountDescriptionColumnDefinition,
];
